import { render, staticRenderFns } from "./SchoolSocialPassportReportTable.vue?vue&type=template&id=4ba73f59&"
import script from "./SchoolSocialPassportReportTable.vue?vue&type=script&lang=js&"
export * from "./SchoolSocialPassportReportTable.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSocialPassportReportTable.vue?vue&type=style&index=0&id=4ba73f59&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports